var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoAvantApres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,4.6C30.4,5,30.5,3,30.5,32c0,24.7,0,26.4,0.2,26.7c0.4,0.6,1.1,0.9,1.9,0.6c0.4-0.2,0.6-0.3,0.8-0.6 c0.2-0.5,0.2-2,0.2-26.7c0-29.1,0.1-27-0.8-27.4C32.2,4.5,31.8,4.5,31.3,4.6 M21.6,13.9c-0.2,0.1-4.1,4.1-8.8,8.7 c-6.4,6.4-8.5,8.7-8.6,9c0,0.3,0,0.5,0.1,0.7C4.4,32.7,21.1,49.7,21.6,50s1.1,0.2,1.5-0.2c0.5-0.5,0.8-1,0.7-1.4 c-0.1-0.3-2-2.2-8-8.4c-4.3-4.4-7.9-8-7.9-8.1s3.5-3.7,7.9-8.1c6-6.1,7.9-8,8-8.4c0.1-0.4-0.2-1-0.7-1.4 C22.6,13.7,22.1,13.6,21.6,13.9 M40.9,14.1c-0.5,0.4-0.8,1-0.7,1.4c0.1,0.3,2,2.3,8,8.4c4.3,4.4,7.9,8,7.9,8.1 c0,0.1-3.5,3.7-7.9,8.1c-6,6-7.9,8.1-8,8.4c-0.1,0.5,0.2,1,0.7,1.4c0.5,0.4,1,0.5,1.5,0.2c0.5-0.3,17.3-17.3,17.4-17.6 c0.1-0.3,0.1-0.4,0.1-0.7c-0.1-0.3-2.2-2.6-8.6-9c-4.7-4.8-8.6-8.6-8.8-8.7C41.9,13.6,41.4,13.7,40.9,14.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAvantApres);
export default __webpack_public_path__ + "static/media/picto-avant-apres.952e23478c302f00e19da769b7f1b1fc.svg";
export { ForwardRef as ReactComponent };